import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { admin } from '../../api/client.js'
import FeederForm, { emptyFeeder, toBody } from '../../components/admin/FeederForm.jsx'
import { btn, Notice, SecretsBox, useAction } from '../../components/admin/ui.jsx'

export default function AdminFeederNewPage() {
  const { t } = useTranslation()
  const [form, setForm] = useState(emptyFeeder)
  const [created, setCreated] = useState(null)
  const { status, busy, run } = useAction()

  const submit = async (e) => {
    e.preventDefault()
    const res = await run(() => admin.create(toBody(form, { create: true })))
    if (res) setCreated(res)
  }

  return (
    <main className="mx-auto flex max-w-4xl flex-col gap-6 px-4 pt-8 pb-16 sm:px-8">
      <Link to="/admin" className="text-sm font-bold text-subtle no-underline hover:text-ink">
        {t('admin.back')}
      </Link>
      <h1 className="text-[clamp(28px,3.5vw,40px)] font-black tracking-[-1px]">{t('admin.newFeeder')}</h1>

      {created ? (
        <div className="flex flex-col gap-4">
          <SecretsBox provisioning={created.provisioning} warnings={created.warnings} />
          <Link to={`/admin/feeders/${created.feeder.slug}`} className={`${btn.dark} self-start no-underline`}>
            {t('admin.edit')} →
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-5">
          <FeederForm value={form} onChange={setForm} create />
          <div className="flex items-center gap-3">
            <button type="submit" disabled={busy || form.lat == null} className={btn.primary}>
              {t('admin.form.create')}
            </button>
            <Notice status={status} />
          </div>
        </form>
      )}
    </main>
  )
}
